import { BasePool } from 'core/components/reels/symbols/base/BasePool'
import { ReelSymbol } from 'core/components/reels/symbols/base/ReelSymbol'
import Container from 'core/display/Container'
import Spine from 'core/display/Spine'
import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { reelsSettings, spinSettings } from 'settings/custom/reels'
import { delay } from 'utils/Delay'
import { Device } from 'utils/Device'

export default class HorizontalReel extends Container{
  constructor(data) {
    super()
    this.symbols = new Container()
    this.back = new Container()
    this.symbolPool = new BasePool()
    this.id = parseFloat(data.name.match(/\d+/))
    this.itemCount = reelsSettings.itemCount[this.id]
    this.reelItems = []
    this.tweenEnd = data.x + data.width * (1 + 1 / this.itemCount)
    this.tweenStart = data.x
    this.settings = spinSettings
    this.addChild(this.symbols, this.back)

    this.createSignal()
  }

  createSignal(){
    signal.once('STATE:OUT:INIT', this.initReel.bind(this))
  }

  initReel() {
    for (let i = 0; i < this.itemCount * 2 + 1; i++) {
      if (i != this.itemCount) {
        const item = new ReelSymbol(this.symbolPool)
        const itemWidth = game.models.ItemsModel.width
        item.x = (i - this.itemCount - 1) * itemWidth
        this.symbols.addChild(item)
        this.reelItems.push(item)
      }
      else {
        this.reelItems.push(new Container)// todo check?
      }
    }
    this.symbols.x = this.tweenEnd
    this.setSymbols()
  }

  setSymbols() {
    for (let i = 0; i < this.itemCount; i++) {
      const symbol = game.models.SpinModel.get().matrix[i][this.id]
      const item = this.reelItems[i]
      item.pos = i
      item.setSymbol(symbol)
      game.models.SpinModel.setSymbol(i, this.id, item)
      item.setType('inactive')
    }
  }

  replace() {
    for (let i = 0; i < this.itemCount; i++) {
      const item = this.reelItems[i + this.itemCount + 1]
      item.setSymbol(this.reelItems[i].getSymbol())
      item.setType(this.reelItems[i].getType())
    }
  }

  async move() {
    return new Promise((resolve) => {
      gsap.fromTo(this.symbols, this.settings.move.time, { x: this.tweenStart }, {
        x: this.tweenEnd,
        ease: this.settings.move.ease,
        onComplete: resolve,
      })
      gsap.fromTo(this.back, this.settings.move.time, { x: this.tweenStart }, {
        x: this.tweenEnd,
        ease: this.settings.move.ease,
      })
    })
  }

  setPenguinAnim(animation) {
    this.back.removeChildren()
    const spine = new Spine(animation)
    const isDesktop = Device.isDesktop()
    spine.scale.set(isDesktop ? 1 : 0.5)
    spine.x = isDesktop ? animation.x : animation.x - (animation.x / 2) / 2
    spine.y = isDesktop ? animation.y : animation.y / 2
    this.back.addChild(spine)
    return spine.play()
  }

  async start() {
    this.back.x = this.tweenStart
    await delay(this.id * 0.27)
    await this.setPenguinAnim(reelsSettings.moveFeature.intro)
    this.setPenguinAnim(reelsSettings.moveFeature.idle)
    this.replace()
    this.setSymbols()
    await this.move()
    this.back.removeChildren()
  }
}
